import React from 'react'
import { Image, MenuItem, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Authenticated from '../../lib/Authenticated'
import { getOrganization } from '../../lib/utils'
import AlertModal from '../fragments/AlertModal'
import UIAvatar from '../fragments/UIAvatar'
import StopImpersonationModal from './StopImpersonationModal'
import store from "store"
import { menuLinks } from './MenuLeft'
import { browserHistory, Link } from "react-router"
import NotificationPopover from '../Notifications/NotificationPopover'
import DownloadRequestPopover from '../DownloadRequests/DownloadRequestPopover'

export default class CustomNavbar extends React.Component {

  authenticated = new Authenticated()
  isSuper = this.authenticated.isSuper()
  isAdmin = this.authenticated.isAdmin()
  isAccountant = this.authenticated.isAccountant()
  isPaymentManager = this.authenticated.isPaymentManager()

  canISeeReports = this.isSuper || this.isAdmin || this.isAccountant || this.isPaymentManager
  canSeeAccountingReport = this.isSuper || this.isAdmin || this.isAccountant
  canSeeFinancierReport = this.isSuper || this.isAdmin || this.isAccountant

  state = {
    impersonate: false,
    organization: null,
    logout: false,
    expanded: false,
  }

  stopImpersonation = () => this.setState({
    organization: getOrganization(),
    impersonate: true,
    expanded: false,
  })

  logoutClicked = () => this.setState({
    logout: true,
    expanded: false,
  })

  onToggle = () => this.setState({ expanded: !this.state.expanded})

  goToLink = link => {
    this.setState({ expanded: false })
    browserHistory.push(link)
    return false
  }

  renderReportLink = (key, uri, text) =>
    <MenuItem eventKey={ key } onClick={() => this.goToLink('/reports/' + uri)} className='pt-5'>
      <UIAvatar name={ text } size={ 22 } />&nbsp; { text }
    </MenuItem>

  renderAccountingReportLinks = () => (
    <NavDropdown eventKey={4}
      title={<span id="report-header-2"><FontAwesome name='money' size="lg" /> &nbsp; Accounting</span>}
      id="accounting-report-nav-dropdown">

      { this.renderReportLink(4.1, 'general-ledger-report', 'General Ledger Report') }
      { this.renderReportLink(4.2, 'income-statement', 'Income Statement') }
      { this.renderReportLink(4.3, 'balance-sheet', 'Balance Sheet') }
      { this.renderReportLink(4.4, 'trial-balance', 'Trial Balance') }

    </NavDropdown>
  )

  renderFinancierReportLinks = () => (
    <NavDropdown eventKey={5}
      title={<span id="report-header-3"><FontAwesome name='underline' size="lg" /> &nbsp; Financiers</span>}
      id="financier-report-nav-dropdown">

      { this.renderReportLink(5.1, 'batch-performance', 'Batch Performance') }
      { this.renderReportLink(5.2, 'bucket-performance', 'Bucket Performance') }

    </NavDropdown>
  )

  renderReportNav = () => (
    <NavDropdown eventKey={2}
      title={<span id="report-header"><FontAwesome name='bar-chart-o' /> Reports</span>}
      id="report-nav-dropdown">

      { this.renderReportLink(2.1, 'active-loans', 'Active Loans') }
      { this.renderReportLink(2.2, 'expected-payment-by-date', 'Expected Payment By Date') }
      { this.renderReportLink(2.3, 'balance-outstanding', 'Balance Outstanding') }
      { this.renderReportLink(2.4, 'aging-detail', 'Aging Detail') }
      { this.renderReportLink(2.5, 'portfolio-at-risk', 'Portfolio At Risk') }
      { this.renderReportLink(2.6, 'branch-cash-in', 'Branch Cash In') }
      { this.renderReportLink(2.7, 'loan-generality', 'Loan Generality') }
      { this.renderReportLink(2.8, 'loans-disbursed-by-affiliation', 'Loans Disbursed By Affiliation') }
      { this.renderReportLink(2.9, 'defaulted-loans', 'Defaulted Loans') }

      <MenuItem divider />
      { this.canSeeAccountingReport && this.renderAccountingReportLinks() }
      <MenuItem divider />
      { this.canSeeFinancierReport && this.renderFinancierReportLinks() }
    </NavDropdown>
  )

  userMdIcon = <FontAwesome name='user-md' size="lg" />

  impersonationIcon = () => this.authenticated.isImpersonation() 
    ? <span> &nbsp; { this.userMdIcon }</span>
    : null

  renderNotificationTrigger = (mobile = false) => (
    <div className={`mx-10 ${ mobile ? 'notification-btn-mobile' : 'notification-btn-cont' }`}>
      <NotificationPopover />
    </div>
  )

  renderDownloadRequestTrigger = (mobile = false) => {
    return (
      <div className={`mx-10 ${ mobile ? 'notification-btn-mobile' : 'notification-btn-cont' }`}>
        <DownloadRequestPopover />
      </div>
    )
  }

  renderUserMenu = () => (
    <NavDropdown
      eventKey={3}
      title={<span id="user-email-header">
        <span className='username-logo'><FontAwesome name='user-circle' size='lg' /></span>
          &nbsp; { this.authenticated.getEmail() } { this.impersonationIcon() }
        </span>
      }
      id="account-nav-dropdown">

      { this.authenticated.isImpersonation() &&
      <MenuItem eventKey={3.1} onClick={ this.stopImpersonation } className='pv-10'>
        <span className='red'>
          { this.userMdIcon } &nbsp; Stop impersonation
        </span>
      </MenuItem>
      }

      <MenuItem eventKey={3.2}>
        <strong>
          { this.authenticated.getUsername() } ({ this.authenticated.getAuthority() })
        </strong>
      </MenuItem>

      <MenuItem eventKey={3.4} className='pt-10' onClick={() => this.goToLink('/my-account') }>
        <FontAwesome name='cog' size='lg' /> &nbsp; My account
      </MenuItem>

      <MenuItem eventKey={3.3} className='pt-10'>
        <small className='last-login'>
          Last login: { store.get('lastLogin') }
        </small>
      </MenuItem>

      <MenuItem divider />

      <MenuItem eventKey={3.5} onClick={ this.logoutClicked }>
        <span className='logout-text'>
          <FontAwesome name='sign-out' size='lg' /> &nbsp; Sign out
        </span>
      </MenuItem>
    </NavDropdown>
  )

  render() {

    const { impersonate, organization, logout, expanded } = this.state

    return (
      <Navbar id="header-container" fixedTop fluid expanded={ expanded }
        onToggle={ this.onToggle } className="pt-3">

        <Navbar.Header>

          <Navbar.Brand>
            <Link to='/home' className='flex-row-simple items-center gap-8'>
              <Image className="text-red-500" src={ require('../../files/favicon.png') } alt='Logo' width="22" />
              AION Onboarding
            </Link>
          </Navbar.Brand>

          <div className='flex justify-end items-center'>
            <div className='visible-xs-block'>
              { this.renderDownloadRequestTrigger(true) }
            </div>
            <div className='visible-xs-block'>
              { this.renderNotificationTrigger(true) }
            </div>
            <Navbar.Toggle />
          </div>
        </Navbar.Header>

        <Navbar.Collapse>

          <Nav className='md:m_hide'>
          { menuLinks().map(({ to, icon, title, authorized }, index) => authorized &&
            <NavItem key={ index } href="#" title={ title } eventKey={index + 6}
              onClick={() => this.goToLink(to)}>
              <span className='inline-block w-32'>
                <FontAwesome name={ icon } size="lg" />
              </span> { title }
            </NavItem>
          )}
          </Nav>

          <Nav pullRight>
            { this.canISeeReports && this.renderReportNav() }

            <li className='hide _md:block'>
              { this.renderDownloadRequestTrigger() }
            </li>

            <li className='hide _md:block'>
              { this.renderNotificationTrigger() }
            </li>
            { this.renderUserMenu() }
          </Nav>
        </Navbar.Collapse>

        { organization
        ? <StopImpersonationModal
            organization={ organization }
            show={ impersonate }
            close={() => this.setState({ impersonate: false })}
          />
        : null
        }

        <AlertModal
          show={ logout }
          title='Sign out'
          body={ <h3 className="red">You are going to sign out!</h3> }
          bsStyle="danger"
          close={() => this.setState({ logout: false })}
          confirm={() => browserHistory.push("/sign-out")}
          proceedText="Sign out"
        />
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App/CustomNavbar.js